export const SIDEBAR_NAME = {
  addQuestion: "addQuestion",
  clickBehavior: "clickBehavior",
  editParameter: "editParameter",
  sharing: "sharing",
  info: "info",
};
